import * as React from 'react';
import { DayPicker as DatePicker, DayPickerDefaultProps } from 'react-day-picker';

export const DayPicker = (props: React.ComponentPropsWithoutRef<typeof DatePicker>) => {
  const isRangeMode = props.mode === 'range';

  return <DatePicker classNames={isRangeMode ? rangeModeClassNames : singleModeClassNames} {...props} />;
};

const singleModeClassNames: DayPickerDefaultProps['classNames'] = {
  cell: 'align-middle text-center border-0 p-0 w-10 h-10 font-light text-sm rounded-xl hover:bg-gray-20',
  day_selected: 'text-white bg-primary-50 rounded-xl font-light m-0.5',
  table: 'w-full items-center flex flex-col pb-1 px-1',
  day_disabled: 'text-gray-400 cursor-not-allowed opacity-50',
};

const rangeModeClassNames: DayPickerDefaultProps['classNames'] = {
  cell: 'align-middle text-center border-0 p-0 w-10 h-10 font-light text-sm',
  day_selected: 'text-black bg-primary-50',
  day_outside: 'text-gray-60',
  day_range_middle: 'rounded-none !bg-gray-20',
  day_range_end: 'rounded-r-xl !text-white',
  day_range_start: 'rounded-l-xl !text-white',
  table: 'w-full items-center flex flex-col',
};
